module.exports = __webpack_public_path__ + "static/img/22.b4c3542.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/3/22.png
// module id = zXJM
// module chunks = 0